import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntityFormMode } from '@/common/entityFramework/enumerations/EntityFormMode';
import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { useMemo } from 'react';

export const ProgTierCalcType = ({ fieldDef }) => {

  const { entityFormMode } = useEntityMgr();
  const { formValues } = useForm();

  const updatedFieldDef = useMemo(() => {
    fieldDef.disabled = !formValues.tierBased || entityFormMode === EntityFormMode.VIEW;
    return fieldDef;
  }, [formValues.tierBased]);

  if (!formValues.tierBased) return;

  return <EnumSelect fieldDef={updatedFieldDef} />
}